export const HOME = '/';
export const WHY_CHOOSE_US = '/why-choose-us';
export const OUR_SERVICES = '/our-services';
export const INDUSTRIES = '/industries';
export const JOB_OPENINGS = '/job-openings';
export const CONTACT_US = '/contact-us';